module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Text-width-397f6020bef3fabd0668608788b020a6.svg";